import React from 'react';
import './tag-chip.css';
/** Category/tag presentation, deliberately separate from workflow status badges. */
export function TagChip({children,tone='neutral',className='',...props}){return <span className={['bs-tag-chip',className].filter(Boolean).join(' ')} data-tone={tone} {...props}>{children}</span>;}
export default TagChip;
